import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import {
  setShowSelectedLocationItems,
  toggleAssignableLocationGroups,
  toggleAllAssignableLocationGroups,
  setHideSelectedLocationItems,
  filterGroupAssociates,
} from 'store/Group/actions'

import Search from '../../../Search'
import SelectedItems from '../../../SelectedItems'

const LocationGroupModal = (props) => {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const { items, associateType } = props

  const isChecked = (props, property, value) => {
    return props[property].indexOf(value) !== -1
  }

  return (
    <Modal
      className='modal-dialog-centered'
      isOpen={props.isOpen}
      size='xl'
      toggle={() => props.setLocationGroupModal(!props.isOpen)}
      scrollable
    >
      <ModalHeader
        className='border-bottom pb-2'
        toggle={() => props.setLocationGroupModal(false)}
      >
        <span className='text-info'>Location group</span>
      </ModalHeader>

      <ModalBody className='scrollbar' style={{ minHeight: '60vh' }}>
        <Row className='justify-content-between px-2'>
          <p>All Location Groups:</p>
          <Search
            placeholder={'Search locations groups'}
            value={groups.filterGroupAssociatesValue}
            onChange={(e) => dispatch(filterGroupAssociates(e.target.value))}
          />
        </Row>
        <div className='col'>
          <div className='col-3 mb-3 pl-0'>
            <SelectedItems
              items={
                items.groups &&
                items.groups.length > 0 &&
                items.groups
                  .filter((item) =>
                    groups.assignableTrainingLocationGroups.includes(item.id)
                  )
                  .sort((a, b) => (a.filterField > b.filterField ? 1 : -1))
              }
              selectedItems={groups.assignableTrainingLocationGroups}
              showSelectedItems={groups.showSelectedLocationItems}
              hasDisabledProperty={false}
              onChange={toggleAssignableLocationGroups}
              setShowSelectedItems={() =>
                dispatch(setShowSelectedLocationItems())
              }
              setHideSelectedItems={() =>
                dispatch(setHideSelectedLocationItems())
              }
              // language={props.language}
            />
          </div>
          {items.groups.filter((item) => item.type === associateType).length ? (
            <div className='custom-control custom-checkbox-info mt-4'>
              <input
                className='custom-control-input'
                id='allStores'
                type='checkbox'
                onChange={() => dispatch(toggleAllAssignableLocationGroups())}
                checked={
                  items.groups &&
                  items.groups.filter((item) => item.type === associateType)
                    .length === groups.selectedLocationGroups.length
                }
              />
              <label className='custom-control-label' htmlFor='allStores'>
                All
              </label>
            </div>
          ) : null}
          {items.groups
            .filter(
              (item) =>
                item.type === associateType &&
                item.name
                  .toLocaleLowerCase()
                  .indexOf(groups.filterGroupAssociatesValue.toLowerCase()) !==
                  -1
            )
            .map((item, index) => (
              <div
                className='custom-control custom-checkbox-info mb-1'
                key={index}
              >
                <input
                  className='custom-control-input'
                  id={`checkbox${index}`}
                  type='checkbox'
                  onChange={() =>
                    dispatch(toggleAssignableLocationGroups(item.id))
                  }
                  checked={isChecked(
                    groups,
                    'assignableTrainingLocationGroups',
                    item.id
                  )}
                />
                <label
                  className='custom-control-label'
                  htmlFor={`checkbox${index}`}
                >
                  {item.name && item.name}
                </label>
              </div>
            ))}
        </div>
      </ModalBody>
      <ModalFooter className='border-top py-2'>
        <Button
          className='ml-auto'
          color='link'
          data-dismiss='modal'
          type='button'
          onClick={() => props.setLocationGroupModal(false)}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default LocationGroupModal
